import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import { formatImage } from '@ifeng-fe/public_method';

class NewsList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.newsList}>
                {content.map((item, index) => (
                    <a
                        className={styles.lietitem}
                        key={index}
                        href={`//news.ifeng.com/c/${item.docId}`}
                        target="_blank">
                        <img src={formatImage(item.thumbnail, 130, 72)} alt="" />
                        <span className={styles.title}>{item.title}</span>
                    </a>
                ))}
            </div>
        );
    }
}

export default errorBoundary(NewsList);
